import type { NotificationAction } from '@houzy/schemas/partner-cockpit/notifications';
import type { LinkOptions } from '@tanstack/react-router';

// Internal targets resolve to an in-app route (navigated via TanStack Router's Link); externalLink
// carries its own destination and must open as a plain anchor instead.
export type NotificationLinkTarget = { type: 'internal'; options: LinkOptions } | { type: 'external'; url: string };

// A switch narrows `action` per-branch on `target`, so `entityUuid`/`url` type-check only where the
// discriminated union actually declares them — a keyed lookup object loses that narrowing.
export function notificationLinkOptions(action: NotificationAction | undefined): NotificationLinkTarget | undefined {
    if (!action) {
        return undefined;
    }
    switch (action.target) {
        case 'teamMembers':
            return { type: 'internal', options: { to: '/settings/members' } };
        case 'companySettings':
            return { type: 'internal', options: { to: '/settings/company' } };
        case 'verification':
            return { type: 'internal', options: { to: '/settings/verification' } };
        case 'openRequestDetail':
            return {
                type: 'internal',
                options: {
                    to: '/open-requests/$offerRequestLeadUuid',
                    params: { offerRequestLeadUuid: action.entityUuid },
                },
            };
        case 'externalLink':
            return { type: 'external', url: action.url };
    }
}
